import React from 'react';
import styled from 'styled-components';

const InfoBlock = (props: Props) => {
	return (
		<Block>
			<TextInBlock>{props.text}</TextInBlock>
		</Block>
	);
};

interface Props {
	text: string;
}

const Block = styled.div`
	background-color: #f2f2f2;
	padding: 12px 30px;
	display: flex;
	flex-direction: row;
	justify-content: center;
`;

const TextInBlock = styled.p`
	font-size: 11px;
	line-height: 15px;
	color: #000;
	text-align: center;
`;

export default InfoBlock;
